import React, { useContext, useEffect, useRef, useState} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';
import Slider, { Range } from 'rc-slider';
import ZoomMinusIcon from '@assets/icons/zoomMinusIcon';
import ZoomPlusIcon from '@assets/icons/zoomPlusIcon';
import HandIcon from '@assets/icons/handIcon';
import Tooltip from '@components/Tooltip';
import GridOverlayIcon from '@assets/icons/gridOverlayIcon';
import AddArtboardIcon from '@assets/icons/addArtboardIcon';
import CreateNew from '@routes/private/Studio/components/CreateNew';

import AddArtboard from '../AddArtboard';
import { IDSConfig } from '@state/dsconfig/types';
import selectors from '@state/selectors';
import { useSelector } from 'react-redux';
import ClickOutside from '@components/ClickOutside';
import { isConstructorDeclaration } from 'typescript';
import { over } from 'lodash';

const GridOverlay: React.FC<IProps> = (props) => {
  let context = useContext(Context);
  const [showGrid, setShowGrid]= useState(false);  
  const [overGrid, setOverGrid]= useState(false);  
  const [showGridSize, setShowGridSize]= useState(false);  
  const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [gridSize, setGridSize]= useState<number|undefined>(dsConfig.editorConfig.gridOverlayConfig.defaultSize);
  const [inputGridSize, setInputGridSize]= useState<string>(dsConfig.editorConfig.gridOverlayConfig.defaultSize.toString());

  const inputValue = useRef() as React.MutableRefObject<HTMLInputElement>;

  const startGridSlider = dsConfig.editorConfig.gridOverlayConfig.defaultSize;
  const minGridSlider = dsConfig.editorConfig.gridOverlayConfig.minSize;
  const maxGridSlider = dsConfig.editorConfig.gridOverlayConfig.maxSize;
  

  const handleGrid=()=>{
    setShowGrid(!showGrid);
    context.onShowGridOverlay(!showGrid)    
  }

  const SetGridSize = (value: number|undefined, notSave?:boolean) => {  
    setGridSize(value);
    if (value)
      context.onChangeGridOverlaySize(value)  
  }
  const handleInputGridSlider = (e: any) => {
    
    
      const inputText = e.target.value.replace("px","");      
      if (!isNaN(inputText) && parseFloat(inputText)<=maxGridSlider) 
        setInputGridSize(inputText);    
      if (!isNaN(inputText) && parseFloat(inputText)>=minGridSlider && parseFloat(inputText)<=maxGridSlider) {
        SetGridSize(parseFloat(inputText));
      }   
              
    
      setTimeout(()=>{
        let value = parseFloat(inputValue.current.value.replace("px",""));
        if (value<minGridSlider && gridSize) {
          setInputGridSize(gridSize.toString());    
        }
      },1000)   
  }


  useEffect(()=>{
    if (showGrid)    
      handleShowGridSize(showGrid)
    else
      setShowGridSize(false)
  },[showGrid])



  const handleShowGridSize=(value:boolean)=>{
    setOverGrid(true);
    if (showGrid)
        setShowGridSize(value)
  }
  
  return (    
    <>
    {
      context.editorStatus.editMode && !context.editorStatus.showSelectDescribe &&
      <S.Root onClick={handleGrid} onMouseEnter={()=>handleShowGridSize(true)} onMouseLeave={()=>setOverGrid(false)}>      
        <Tooltip tip={"Grid"} boxStyle={{width:"120px", marginLeft:"-20px"}}
          >            
            <GridOverlayIcon  fillColor={(showGrid || overGrid) ? "white" :"#818181"} />
        </Tooltip>            
      </S.Root>
    }
    {    
     <ClickOutside onClickOutside={()=> setShowGridSize(false)} event={"mousedown"}>
        <S.OptionsList style={{ display: showGridSize ? "flex" : "none"}}>
        <S.optionContainer>
            <S.LabelSlider>
              Grid
            </S.LabelSlider>
            <S.SliderContainer>
            <Slider
              min={minGridSlider}
              max={maxGridSlider}
              step={1}              
              value={gridSize!==undefined?gridSize:startGridSlider}
              onChange={(e)=> {SetGridSize(e,true); setInputGridSize(e.toString())}}
              onAfterChange={(e)=> {SetGridSize(e); setInputGridSize(e.toString())}}
              railStyle={{
                height:1,
                background: "#818181"
                
              }}
              handleStyle={{
                height: 10,
                width: 10,                
                marginTop: -4,
                backgroundColor: "#c4c4c4",
                border: 0
              }}
              trackStyle={{
                height:1,
                background: "none"
              }}
              dotStyle={{
                border:0,
                height:5,
                width:5,
                top:-2,
                background: "#c4c4c4"

              }}
              
            />
            </S.SliderContainer>
            <S.InputSlider disabled={false}
              ref={inputValue}
              value={`${inputGridSize!==undefined?inputGridSize:""}px`}
              onChange={handleInputGridSlider}
            ></S.InputSlider>
          </S.optionContainer>        
        </S.OptionsList>       
      </ClickOutside>
      }
    
    </>
        
  );
}
  
export default GridOverlay;